export const FETCH_INVOICES_REQUEST = 'FETCH_INVOICES_REQUEST';
export const FETCH_INVOICES_SUCCESS = 'FETCH_INVOICES_SUCCESS';
export const FETCH_INVOICES_FAILED = 'FETCH_INVOICES_FAILED';

export const FETCH_INVOICE_BY_ID_REQUEST = 'FETCH_INVOICE_BY_ID_REQUEST';
export const FETCH_INVOICE_BY_ID_SUCCESS = 'FETCH_INVOICE_BY_ID_SUCCESS';
export const FETCH_INVOICE_BY_ID_FAILED = 'FETCH_INVOICE_BY_ID_FAILED';
export const FETCH_INVOICE_BY_ID_RESET = 'FETCH_INVOICE_BY_ID_RESET';

export const FETCH_ACCOUNT_EMITTER_REQUEST = 'FETCH_ACCOUNT_EMITTER_REQUEST';
export const FETCH_ACCOUNT_EMITTER_SUCCESS = 'FETCH_ACCOUNT_EMITTER_SUCCESS';
export const FETCH_ACCOUNT_EMITTER_FAILED = 'FETCH_ACCOUNT_EMITTER_FAILED';

export const FETCH_PROCESS_INVOICE_BY_ID_REQUEST = 'FETCH_PROCESS_INVOICE_BY_ID_REQUEST';
export const FETCH_PROCESS_INVOICE_BY_ID_SUCCESS = 'FETCH_PROCESS_INVOICE_BY_ID_SUCCESS';
export const FETCH_PROCESS_INVOICE_BY_ID_FAILED = 'FETCH_PROCESS_INVOICE_BY_ID_FAILED';

export const FETCH_PROCESS_INVOICES_BY_IDS_REQUEST = 'FETCH_PROCESS_INVOICES_BY_IDS_REQUEST';
export const FETCH_PROCESS_INVOICES_BY_IDS_SUCCESS = 'FETCH_PROCESS_INVOICES_BY_IDS_SUCCESS';
export const FETCH_PROCESS_INVOICES_BY_IDS_FAILED = 'FETCH_PROCESS_INVOICES_BY_IDS_FAILED';

export const FETCH_ADD_ITEM_TO_INVOICE_REQUEST = 'FETCH_ADD_ITEM_TO_INVOICE_REQUEST';
export const FETCH_ADD_ITEM_TO_INVOICE_SUCCESS = 'FETCH_ADD_ITEM_TO_INVOICE_SUCCESS';
export const FETCH_ADD_ITEM_TO_INVOICE_FAILED = 'FETCH_ADD_ITEM_TO_INVOICE_FAILED';

export const FETCH_UPDATE_INVOICE_ITEM_REQUEST = 'FETCH_UPDATE_INVOICE_ITEM_REQUEST';
export const FETCH_UPDATE_INVOICE_ITEM_SUCCESS = 'FETCH_UPDATE_INVOICE_ITEM_SUCCESS';
export const FETCH_UPDATE_INVOICE_ITEM_FAILED = 'FETCH_UPDATE_INVOICE_ITEM_FAILED';

export const FETCH_INVOICES_AS_PAID_REQUEST = 'FETCH_INVOICES_AS_PAID_REQUEST';
export const FETCH_INVOICES_AS_PAID_SUCCESS = 'FETCH_INVOICES_AS_PAID_SUCCESS';
export const FETCH_INVOICES_AS_PAID_FAILED = 'FETCH_INVOICES_AS_PAID_FAILED';

export const FETCH_DELETE_ITEM_FROM_INVOICE_REQUEST = 'FETCH_DELETE_ITEM_FROM_INVOICE_REQUEST';
export const FETCH_DELETE_ITEM_FROM_INVOICE_SUCCESS = 'FETCH_DELETE_ITEM_FROM_INVOICE_SUCCESS';
export const FETCH_DELETE_ITEM_FROM_INVOICE_FAILED = 'FETCH_DELETE_ITEM_FROM_INVOICE_FAILED';

export const FETCH_INVOICE_SOURCES_REQUEST = 'FETCH_INVOICE_SOURCES_REQUEST';
export const FETCH_INVOICE_SOURCES_SUCCESS = 'FETCH_INVOICE_SOURCES_SUCCESS';
export const FETCH_INVOICE_SOURCES_FAILED = 'FETCH_INVOICE_SOURCES_FAILED';

export const FETCH_SEND_EMAIL_INVOICE_REQUEST = 'FETCH_SEND_EMAIL_INVOICE_REQUEST';
export const FETCH_SEND_EMAIL_INVOICE_SUCCESS = 'FETCH_SEND_EMAIL_INVOICE_SUCCESS';
export const FETCH_SEND_EMAIL_INVOICE_FAILED = 'FETCH_SEND_EMAIL_INVOICE_FAILED';

export const FETCH_REFUND_REQUEST = 'FETCH_REFUND_REQUEST';
export const FETCH_REFUND_SUCCESS = 'FETCH_REFUND_SUCCESS';
export const FETCH_REFUND_FAILED = 'FETCH_REFUND_FAILED';

export const RESET_REFUND_SUCCESS = 'RESET_REFUND_SUCCESS';

export const FETCH_EXPORT_INVOICE_REQUEST = 'FETCH_EXPORT_INVOICE_REQUEST';
export const FETCH_EXPORT_INVOICE_SUCCESS = 'FETCH_EXPORT_INVOICE_SUCCESS';
export const FETCH_EXPORT_INVOICE_FAILED = 'FETCH_EXPORT_INVOICE_FAILED';

export const FETCH_CREATE_INVOICE_REQUEST = 'FETCH_CREATE_INVOICE_REQUEST';
export const FETCH_CREATE_INVOICE_SUCCESS = 'FETCH_CREATE_INVOICE_SUCCESS';
export const FETCH_CREATE_INVOICE_FAILED = 'FETCH_CREATE_INVOICE_FAILED';

export const FETCH_UPDATE_INVOICE_REQUEST = 'FETCH_UPDATE_INVOICE_REQUEST';
export const FETCH_UPDATE_INVOICE_SUCCESS = 'FETCH_UPDATE_INVOICE_SUCCESS';
export const FETCH_UPDATE_INVOICE_FAILED = 'FETCH_UPDATE_INVOICE_FAILED';

export const FETCH_PUBLISH_INVOICE_REQUEST = 'FETCH_PUBLISH_INVOICE_REQUEST';
export const FETCH_PUBLISH_INVOICE_SUCCESS = 'FETCH_PUBLISH_INVOICE_SUCCESS';
export const FETCH_PUBLISH_INVOICE_FAILED = 'FETCH_PUBLISH_INVOICE_FAILED';

export const SET_EXIT = 'SET_EXIT';
export const RESET_WIZARD = 'RESET_WIZARD';
export const CHANGE_POSITION = 'CHANGE_POSITION';

export const FETCH_UPDATE_INVOICE_APPROVAL_REQUEST = 'FETCH_UPDATE_INVOICE_APPROVAL_REQUEST';
export const FETCH_UPDATE_INVOICE_APPROVAL_SUCCESS = 'FETCH_UPDATE_INVOICE_APPROVAL_SUCCESS';
export const FETCH_UPDATE_INVOICE_APPROVAL_FAILED = 'FETCH_UPDATE_INVOICE_APPROVAL_FAILED';
